export const SET_WEBSITE_ACCOUNT_FILTERS = 'SET_WEBSITE_ACCOUNT_FILTERS';
export const setWebAccountFilters = (filterData: any) => ({
  type: SET_WEBSITE_ACCOUNT_FILTERS,
  payload: filterData,
});

const initialState: any = {};

interface Action {
  type: string;
  payload: any;
}

const webAccountFilterReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_WEBSITE_ACCOUNT_FILTERS:
      return {
        ...action.payload,
      };
    default:
      return state;
  }
};
export default webAccountFilterReducer;
